import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import WarehouseReceiptService from "services/warehouseReceiptService";
import Utils from "utils";
import openNotification from "utils/notification";

// WAREHOUSE RECEIPT
export const getAllWarehouseReceipt = createAsyncThunk(
  "manageWarehouseReceipt/getAllWarehouseReceipt",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await WarehouseReceiptService.getAllWarehouseReceipt(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const generateWarehouseReceipt = createAsyncThunk(
  "manageWarehouseReceipt/generateWarehouseReceipt",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await WarehouseReceiptService.generateWarehouseReceipt(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const generateWarehouseReceiptV2 = createAsyncThunk(
  "manageWarehouseReceipt/generateWarehouseReceiptV2",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await WarehouseReceiptService.generateWarehouseReceiptV2(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createWarehouseReceipt = createAsyncThunk(
  "manageWarehouseReceipt/createWarehouseReceipt",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await WarehouseReceiptService.createWarehouseReceipt(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateWarehouseReceipt = createAsyncThunk(
  "manageWarehouseReceipt/updateWarehouseReceipt",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await WarehouseReceiptService.updateWarehouseReceipt(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateWarehouseReceiptV2 = createAsyncThunk(
  "manageWarehouseReceipt/updateWarehouseReceiptV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await WarehouseReceiptService.updateWarehouseReceiptV2(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateWarehouseReceiptPartial = createAsyncThunk(
  "manageWarehouseReceipt/updateWarehouseReceiptPartial",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await WarehouseReceiptService.updateWarehouseReceiptPartial(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateWarehouseReceiptMaterial = createAsyncThunk(
  "manageWarehouseReceipt/updateWarehouseReceiptMaterial",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await WarehouseReceiptService.updateWarehouseReceiptMaterial(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteWarehouseReceipt = createAsyncThunk(
  "manageWarehouseReceipt/deleteWarehouseReceipt",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseReceiptService.deleteWarehouseReceipt(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const deleteWarehouseReceiptMaterial = createAsyncThunk(
  "manageWarehouseReceipt/deleteWarehouseReceiptMaterial",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await WarehouseReceiptService.deleteWarehouseReceiptMaterial(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const getDetailWarehouseReceipt = createAsyncThunk(
  "manageWarehouseReceipt/getDetailWarehouseReceipt",
  async (id, { rejectWithValue }) => {
    try {
      const response =
        await WarehouseReceiptService.getDetailWarehouseReceipt(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

//WAREHOUSE RECEIPT TRANSFER
export const getAllTransfer = createAsyncThunk(
  "manageWarehouseReceipt/getAllTransfer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseReceiptService.getAllTransfer(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const generateTransfer = createAsyncThunk(
  "manageWarehouseReceipt/generateTransfer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseReceiptService.generateTransfer(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const generateTransferV2 = createAsyncThunk(
  "manageWarehouseReceipt/generateTransferV2",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await WarehouseReceiptService.generateTransferV2(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createTransfer = createAsyncThunk(
  "manageWarehouseReceipt/createTransfer",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseReceiptService.createTransfer(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateTransfer = createAsyncThunk(
  "manageWarehouseReceipt/updateTransfer",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseReceiptService.updateTransfer(payload);
      if (onSuccess) onSuccess(response);
      if (response.data.ok) {
        openNotification(
          "success",
          Utils.setLocale("admin.settings.popup.notification.success"),
          Utils.setLocale("admin.settings.popup.notification.title"),
        );
      } else {
        openNotification(
          "warning",
          response.data.description,
          Utils.setLocale("admin.settings.popup.notification.title"),
        );
      }
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateTransferReceivedQuantity = createAsyncThunk(
  "manageWarehouseReceipt/updateTransferReceivedQuantity",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response =
        await WarehouseReceiptService.updateTransferReceivedQuantity(payload);
      if (response.data.ok) {
        if (onSuccess) onSuccess(response);
        openNotification(
          "success",
          Utils.setLocale("admin.settings.popup.notification.success"),
          Utils.setLocale("admin.settings.popup.notification.title"),
        );
      } else {
        openNotification(
          "warning",
          response.data.description,
          Utils.setLocale("admin.settings.popup.notification.title"),
        );
      }
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const confirmTransfer = createAsyncThunk(
  "manageWarehouseReceipt/confirmTransfer",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseReceiptService.confirmTransfer(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const confirmTransferV2 = createAsyncThunk(
  "manageWarehouseReceipt/confirmTransferV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseReceiptService.confirmTransferV2(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteTransfer = createAsyncThunk(
  "manageWarehouseReceipt/deleteTransfer",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseReceiptService.deleteTransfer(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const deleteTransferMaterial = createAsyncThunk(
  "manageWarehouseReceipt/deleteTransferMaterial",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseReceiptService.deleteTransferMaterial(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const getDetailTransfer = createAsyncThunk(
  "manageWarehouseReceipt/getDetailTransfer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await WarehouseReceiptService.getDetailTransfer(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

//WAREHOUSE CHECK
export const getAllCheck = createAsyncThunk(
  "manageWarehouseReceipt/getAllCheck",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseReceiptService.getAllCheck(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const generateCheck = createAsyncThunk(
  "manageWarehouseReceipt/generateCheck",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseReceiptService.generateCheck(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const generateCheckV2 = createAsyncThunk(
  "manageWarehouseReceipt/generateCheckV2",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseReceiptService.generateCheckV2(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getDetailCheck = createAsyncThunk(
  "manageWarehouseReceipt/detailCheck",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseReceiptService.detailCheck(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createCheck = createAsyncThunk(
  "manageWarehouseReceipt/createCheck",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseReceiptService.createCheck(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateCheck = createAsyncThunk(
  "manageWarehouseReceipt/updateCheck",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseReceiptService.updateCheck(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateCheckV2 = createAsyncThunk(
  "manageWarehouseReceipt/updateCheckV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseReceiptService.updateCheckV2(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const cancelCheck = createAsyncThunk(
  "manageWarehouseReceipt/cancelCheck",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseReceiptService.cancelCheck(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getWarehouseUnit = createAsyncThunk(
  "manageWarehouseReceipt/getWarehouseUnit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseReceiptService.getWarehouseUnit(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const initialState = {
  loading: false,
  warehouseReceiptList: [],
  totalCount: 0,
  totalNoInvoice: 0,
  receiptGenerate: {},
  receiptGenerateV2: {},
  detailReceipt: {},

  //WAREHOUSE TRANSFER
  transferList: [],
  transferTotalCount: 0,
  transferGenerate: {},
  transferGenerateV2: {},
  detailTransfer: {},

  //WAREHOUSE CHECK
  checkList: [],
  checkTotalCount: 0,
  checkGenerate: {},
  checkGenerateV2: {},
  detailCheck: {},

  units: [],
};

export const warehouseReceiptSlice = createSlice({
  name: "warehouse-receipt",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllWarehouseReceipt.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllWarehouseReceipt.fulfilled, (state, action) => {
        state.loading = false;
        state.warehouseReceiptList = action.payload;
        state.totalCount = action.payload.totalCount;
        state.totalNoInvoice = action.payload?.totalNoInvoice ?? 0;
      })
      .addCase(getAllWarehouseReceipt.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getDetailWarehouseReceipt.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDetailWarehouseReceipt.fulfilled, (state, action) => {
        state.loading = false;
        state.detailReceipt = action.payload;
      })
      .addCase(getDetailWarehouseReceipt.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(generateWarehouseReceipt.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateWarehouseReceipt.fulfilled, (state, action) => {
        state.loading = false;
        state.receiptGenerate = action.payload;
      })
      .addCase(generateWarehouseReceipt.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(generateWarehouseReceiptV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateWarehouseReceiptV2.fulfilled, (state, action) => {
        state.loading = false;
        state.receiptGenerateV2 = action.payload;
      })
      .addCase(generateWarehouseReceiptV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createWarehouseReceipt.pending, (state) => {
        state.loading = true;
      })
      .addCase(createWarehouseReceipt.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createWarehouseReceipt.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateWarehouseReceipt.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateWarehouseReceipt.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateWarehouseReceipt.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateWarehouseReceiptV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateWarehouseReceiptV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateWarehouseReceiptV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateWarehouseReceiptMaterial.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateWarehouseReceiptMaterial.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateWarehouseReceiptMaterial.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteWarehouseReceipt.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteWarehouseReceipt.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteWarehouseReceipt.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteWarehouseReceiptMaterial.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteWarehouseReceiptMaterial.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteWarehouseReceiptMaterial.rejected, (state, action) => {
        state.loading = false;
      })

      //TRANSFER
      .addCase(getAllTransfer.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllTransfer.fulfilled, (state, action) => {
        state.loading = false;
        state.transferList = action.payload;
        state.transferTotalCount = action.payload.totalCount;
      })
      .addCase(getAllTransfer.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getDetailTransfer.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDetailTransfer.fulfilled, (state, action) => {
        state.loading = false;
        state.detailTransfer = action.payload;
      })
      .addCase(getDetailTransfer.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(generateTransfer.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateTransfer.fulfilled, (state, action) => {
        state.loading = false;
        state.transferGenerate = action.payload;
      })
      .addCase(generateTransfer.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(generateTransferV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateTransferV2.fulfilled, (state, action) => {
        state.loading = false;
        state.transferGenerateV2 = action.payload;
      })
      .addCase(generateTransferV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createTransfer.pending, (state) => {
        state.loading = true;
      })
      .addCase(createTransfer.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createTransfer.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateTransfer.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTransfer.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateTransfer.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateTransferReceivedQuantity.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTransferReceivedQuantity.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateTransferReceivedQuantity.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteTransfer.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTransfer.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteTransfer.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteTransferMaterial.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTransferMaterial.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteTransferMaterial.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(confirmTransfer.pending, (state) => {
        state.loading = true;
      })
      .addCase(confirmTransfer.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(confirmTransfer.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(confirmTransferV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(confirmTransferV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(confirmTransferV2.rejected, (state, action) => {
        state.loading = false;
      })

      //WAREHOUSE CHECK
      .addCase(getAllCheck.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.checkList = action.payload;
        state.checkTotalCount = action.payload.totalCount;
      })
      .addCase(getAllCheck.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getDetailCheck.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDetailCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.detailCheck = action.payload;
      })
      .addCase(getDetailCheck.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(generateCheck.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.checkGenerate = action.payload;
      })
      .addCase(generateCheck.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(generateCheckV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateCheckV2.fulfilled, (state, action) => {
        state.loading = false;
        state.checkGenerateV2 = action.payload;
      })
      .addCase(generateCheckV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createCheck.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCheck.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createCheck.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateCheck.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCheck.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateCheck.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateCheckV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCheckV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateCheckV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(cancelCheck.pending, (state) => {
        state.loading = true;
      })
      .addCase(cancelCheck.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(cancelCheck.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getWarehouseUnit.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWarehouseUnit.fulfilled, (state, action) => {
        state.loading = false;
        state.units = action.payload;
      })
      .addCase(getWarehouseUnit.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateWarehouseReceiptPartial.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateWarehouseReceiptPartial.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateWarehouseReceiptPartial.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = warehouseReceiptSlice.actions;

export default warehouseReceiptSlice.reducer;
